export const blockIconsNotificationPersonalVideo = (
	<span className='material-symbols-outlined'>personal_video</span>
);
